import React, { FC, useState } from 'react';
import { NavFolders } from './folders/NavFolders';
import { Notification } from './notification/components/Notification';
import { NavUser } from './user/NavUser';
import { UserContextType } from '../user/user.types';
import { NavPrivatePricing } from './pricing-button/NavPrivatePricing';
import { NavCodes } from './codes/NavCodes';
import { NavDocumentAnalyzerLink } from './document-analyzer/NavDocumentAnalyzerLink';
import { Nav } from './components/Nav';

type Props = {
  currentUser: UserContextType['currentUser'];
  accessPremium: UserContextType['accessPremium'];
};

/* 
  To manage the hover on NavPrivatePricing
  this context only carries a boolean and the method 
  updating it so that :hover can be prevented 
  if any of the other onClick Dropdown is triggered
*/
export const NavPrivate: FC<Props> = ({
  accessPremium,
  currentUser: { askPhoneNumber },
}) => {
  const [displayDropdown, setDisplayDropdown] = useState({
    user: false,
    folder: false,
    notification: false,
    'document-analyzer': false,
  });

  const cancelHover = (display: boolean, dropdown: string) => {
    setDisplayDropdown((prevState) => ({
      ...prevState,
      [dropdown]: display,
    }));
  };

  return (
    <Nav dataTestId="nav-private">
      <NavPrivatePricing
        noHover={Object.values(displayDropdown).reduce(
          (sum, curr) => sum || curr,
        )}
      />
      <NavCodes />
      <NavDocumentAnalyzerLink />

      {accessPremium && <NavFolders cancelHover={cancelHover} />}
      {!askPhoneNumber && <Notification cancelHover={cancelHover} />}
      <NavUser cancelHover={cancelHover} />
    </Nav>
  );
};
